import type {StateCreator} from 'zustand'
import {ViewMode, type CommentsPanelViewMode} from './comment-view-mode'

export type CommentReplySliceOpts = {
  selectedCommentReplyThreadId?: string
  commentsPanelViewMode?: CommentsPanelViewMode
}

export interface CommentReplySlice {
  selectedCommentReplyThreadId: string | undefined
  commentsPanelViewMode: CommentsPanelViewMode
  commentReplyActions: {
    openReplyDetail: (threadId: string) => void
    clearReplyDetail: () => void
    setCommentsPanelViewMode: (viewMode: CommentsPanelViewMode) => void
  }
}

export const createCommentReplySlice =
  ({
    selectedCommentReplyThreadId,
    commentsPanelViewMode = ViewMode.ThreadPreviews,
  }: CommentReplySliceOpts): StateCreator<CommentReplySlice, [['zustand/devtools', never]], [], CommentReplySlice> =>
  set => ({
    selectedCommentReplyThreadId,
    commentsPanelViewMode,
    commentReplyActions: {
      openReplyDetail: (threadId: string) => {
        set({selectedCommentReplyThreadId: threadId}, undefined, 'openReplyDetail')
      },
      clearReplyDetail: () => {
        set({selectedCommentReplyThreadId: undefined}, undefined, 'clearReplyDetail')
      },
      setCommentsPanelViewMode: viewMode => {
        set(
          state => ({
            commentsPanelViewMode: viewMode,
            selectedCommentReplyThreadId:
              viewMode === ViewMode.IssueComments ? undefined : state.selectedCommentReplyThreadId,
          }),
          undefined,
          'setCommentsPanelViewMode',
        )
      },
    },
  })
